// src/plugins/keycloak.js
import Keycloak from "keycloak-js";

let keycloakInstance;

export async function setupKeycloak(app) {
    const res = await fetch('/keycloak.json');
    const config = await res.json();

    keycloakInstance = new Keycloak(config);

    await keycloakInstance.init({
        onLoad: "login-required",
        checkLoginIframe: false,
        pkceMethod: "S256",
    });

    console.log("Authenticated with Keycloak");

    // Make instance globally available
    app.config.globalProperties.$keycloak = keycloakInstance;

    // Token refresher
    setInterval(() => {
        keycloakInstance.updateToken(30);
    }, 290 * 1000); // 290 seconds
}

export function getKeycloak() {
    return keycloakInstance;
}
